import styled, { css } from 'styled-components';
import { token } from '@bynder/design-system';
import { thinScrollbar } from 'packages/common/globalStyles/thinScrollbar';

export const EditorImageWrapper = styled.div`
    display: flex;
    height: 100%;
    padding-left: 16px;
    background-color: ${token.gray25};
    min-height: 600px;
    overflow: hidden;
    position: relative;
`;

export const EditorMain = styled.main`
    position: relative;
    flex: 1 1 0;
    width: 100%;
    max-width: 100%;
    height: 100%;
    padding: 0 20px;

    ${thinScrollbar}
`;

// Carries `editor-container`, which the timeline resize logic measures.
export const EditorContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    height: 100%;
    margin: 0 -20px;
    padding-top: 20px;
    padding-right: 20px;
`;

export const EditorWorkArea = styled.div<{ $isImageDesign: boolean }>`
    position: relative;
    flex: 1 1 0;
    width: 100%;
    max-width: 100%;
    padding: 0;

    ${({ $isImageDesign }) =>
        $isImageDesign
            ? css`
                  display: flex;
                  height: calc(100% - 160px);
              `
            : css`
                  margin-left: -16px;
                  margin-right: -20px;
                  width: calc(100% + 36px);
                  max-width: none;
              `}
`;

export const CanvasContainerWrapper = styled.div<{ $isImageDesign: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    height: 100%;
    overflow: hidden;
    outline: none;
    -webkit-user-select: none;
    user-select: none;

    ${({ $isImageDesign }) =>
        $isImageDesign &&
        css`
            max-width: calc(100% - 272px + 20px);
            margin-right: -20px;
        `}
`;

export const ShortcutsInfoButtonWrapper = styled(`div`)<{ type: string }>`
    position: absolute;
    bottom: ${({ type }) => (type === 'VIDEO' ? 0 : token.spacing5)};
    right: ${({ type }) => (type === 'VIDEO' ? '20px' : 0)};
`;
